import { getParameterByName } from "@helpers/QueryString";

const getFlagState = (flagName) => getParameterByName(flagName) === "true";

const getPersistentFlagState = (flagName) => {
  const key = `ikea-testing-dyh-${flagName}`;
  const savedValue = window.localStorage.getItem(key);
  if (savedValue === "true") {
    return true;
  }
  const queryParamFlagState = getFlagState(flagName);

  if (queryParamFlagState === true) {
    window.localStorage.setItem(key, "true");
  }

  return queryParamFlagState;
};

export const featureFlags = {
  enable_experimental_features: "enable_experimental_features",
  enable_mobile_design: "enable_mobile_design",
  enable_testing: "enable_testing",
};

export const getEnabledFeatures = () => ({
  [featureFlags.enable_experimental_features]: getFlagState(
    featureFlags.enable_experimental_features
  ),
  [featureFlags.enable_mobile_design]: getPersistentFlagState(
    featureFlags.enable_mobile_design
  ),
  [featureFlags.enable_testing]: getPersistentFlagState(
    featureFlags.enable_testing
  ),
});
